export const validateJSONString = (string) => {
  let newArray = [];
  try {
    newArray = string ? Array.from(JSON.parse(string)) : [];
  } catch (error) {
    console.log(error);
  }
  return newArray;
};
